export default "__VITE_ASSET__BDxRmX5q__"